import { render, staticRenderFns } from "./GalleryOttersweier.vue?vue&type=template&id=968bb4a4&"
import script from "./GalleryOttersweier.vue?vue&type=script&lang=js&"
export * from "./GalleryOttersweier.vue?vue&type=script&lang=js&"
import style0 from "./GalleryOttersweier.vue?vue&type=style&index=0&id=968bb4a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports